// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"48b319af","455":"2dab0b1e","977":"e8ea6fba"}[chunkId] + ".chunk.js";
};